/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum GtmLoggedInTypeEnum {
  LoggedId = 'logged-in',
  NotLoggedId = 'not-logged-in'
}
